import { css } from '@emotion/react';

export const MarketingWidgetStyles = css`
  .MarketingWidget-content,
  .MarketingWidget-messaging {
    border-radius: 8px;
  }

  .MarketingWidget-fullBleedContainer {
    margin-bottom: 6rem;
    padding-bottom: 3.2rem;
    padding-top: 3.2rem;

    @media screen and (min-width: 960px) {
      padding-bottom: 4.8rem;
      padding-top: 4.8rem;
    }
  }

  .MarketingWidget-columns {
    align-content: stretch;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0;

    @media screen and (min-width: 600px) {
      flex-wrap: nowrap;
    }
  }

  .MarketingWidget-column {
    align-content: space-between;
    align-items: center;
    align-self: stretch;
    background: transparent;
    border-radius: 8px;
    display: flex;
    flex: 0 0 100%;
    justify-content: center;

    @media screen and (min-width: 600px) {
      flex: 1 1 50%;
    }
  }

  .MarketingWidget-column + .MarketingWidget-column {
    margin-top: 2.4rem;

    @media screen and (min-width: 600px) {
      margin-left: 2.4rem;
      margin-top: 0;
    }
  }

  .MarketingWidget-content {
    align-items: center;
    align-self: stretch;
    background: transparent;
    display: flex;
    flex: 1 1 100%;
    height: 100%;
    justify-content: center;
    margin: 0;
    padding: 4.8rem 2.4rem;
    text-align: center;
    width: 100%;

    @media screen and (min-width: 960px) {
      padding: 7.2rem 4.8rem;
    }

    .MarketingWidget-subtitle {
      font-size: 1.3rem;
      font-weight: 700;
      line-height: 1;
      margin: 0 auto 2.4rem;

      @media screen and (min-width: 960px) {
        font-size: 1.6rem;
        margin: 0 auto 3.6rem;
      }
    }

    .MarketingWidget-headline {
      font-size: 2.6rem;
      font-weight: 400;
      line-height: 118%;
      margin: 0 auto 3.6rem;
      max-width: 76rem;

      @media screen and (min-width: 600px) {
        font-size: 3.6rem;
        line-height: 118%;
      }

      @media screen and (min-width: 960px) {
        margin: 0 auto 4.8rem;
      }
    }
  }

  .MarketingWidget-blog {
    .MarketingWidget-content {
      align-content: stretch;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      padding: 0;

      @media screen and (min-width: 960px) {
        background-position: right top;
        flex-wrap: nowrap;
      }
    }

    .MarketingWidget-messaging {
      flex: 0 0 100%;
      text-align: left;

      @media screen and (min-width: 600px) {
        flex: 1 1 45%;
        order: 1;
      }

      @media screen and (min-width: 960px) {
        flex: 1 1 60%;
      }

      @media screen and (min-width: 1280px) {
        flex: 1 1 45%;
      }

      .MarketingWidget-subtitle {
        background: transparent;
        display: inline-block;
        font-size: 1.4rem;
        margin: 2.8rem 0 1.2rem;

        @media screen and (min-width: 960px) {
          font-size: 1.6rem;
          margin: 2.4rem 0 2rem;
          margin-bottom: 2rem;
        }
      }

      .MarketingWidget-headline {
        font-size: 5.2rem;
        line-height: 0.9;
        margin: 0;
        text-transform: uppercase;

        @media screen and (min-width: 960px) {
          font-size: 6.4rem;
          margin: 0 0 3.2rem 0;
        }
      }

      .MarketingWidget-paragraph {
        font-size: 1.4rem;
        line-height: 1.3;
        margin-top: 1.6rem;
        padding-right: 0;

        @media screen and (min-width: 960px) {
          font-size: 1.6rem;
          margin-bottom: 3.2rem;
          max-width: 24rem;
        }
      }
    }
  }

  .MarketingWidget-blog {
    .MarketingWidget-content {
      align-items: flex-start;
      background-color: #fdd2a5;
      position: relative;

      .MarketingWidget-messaging {
        z-index: 1;
      }

      .MarketingWidget-headline {
        flex-grow: 1;
        max-width: 28rem;
      }

      .MarketingWidget-blog-graphic {
        display: block;
        flex: 0 0 100%;
        height: auto;
        order: 1;
        position: relative;

        @media screen and (min-width: 840px) {
          bottom: 0;
          height: 100%;
          margin: 0;
          order: 1;
          overflow: hidden;
          padding: 0;
          position: absolute;
          right: 0;
          top: 0;
          width: 60%;
        }

        .graphic-one {
          right: 1.6rem;
          top: 1.6rem;
        }

        .graphic-one img {
          max-width: 17.5rem;
        }

        .graphic-two {
          bottom: -3.4rem;
          right: 0;
        }
      }

      .MarketingWidget-blog-graphic .graphic-one,
      .MarketingWidget-blog-graphic .graphic-two {
        @media screen and (min-width: 600px) {
          position: absolute;
        }
      }

      .MarketingWidget-blog-graphic .graphic-two img {
        width: 100%;

        @media screen and (min-width: 600px) {
          max-width: 31.4rem;
        }
      }

      .MarketingWidget-blog-graphic .graphic-two.MarketingWidget-desktopImage {
        display: none;

        @media screen and (min-width: 960px) {
          bottom: -0.4rem;
        }

        @media screen and (min-width: 960px) {
          display: block;
        }
      }
    }
  }

  .MarketingWidget-mobileApp {
    /* margin: 0; */
    /* padding: 2.4rem; */
    /* padding: 0; */
    @media screen and (min-width: 960px) {
      /* padding: 0; */
    }

    .MarketingWidget-hero {
      @media screen and (min-width: 960px) {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 333px;
        justify-content: center;
        position: relative;
      }
    }

    /* .MarketingWidget-mobileImage {
      width: 100%;

      @media screen and (min-width: 960px) {
        display: none;
      }
    } */
  }

  .MarketingWidget-mobileApp {
    .MarketingWidget-hero {
      @media screen and (min-width: 960px) {
        height: auto;
      }
    }
  }
`;
